import(/* webpackMode: "eager" */ "/app/packages/tokyu-web/app/(pages)/[locale]/authentication/(simple-layout)/layout.tsx");
